import * as Yup from 'yup'
import {validationConfig} from '../../../../validationConfig';

export interface ICreateOrder {
    Ragione_sociale: string
    P_IVA: string
    CF: string
    Email: string
    Email_2: string
    Referente_commerciale: string
    IntermediarioRadio: string
    Intermediario: string
    Modello_visore: number[]
    Piano_abbonamento: string
    Lunghezza_abbonamento: number
    Mese_gratis: boolean
    Simulazioni_scelte: string[]
    Simulazioni_multiplayer_scelte: string[]
    Simulazione_personalizzata_scelta: string
    Num_simulazioni_base: number
    Opzioni_aggiuntive_scelte: string[]
    Importo_effettivo: number
    Note_aggiuntive: string
    Indirizzo_sped: string
    Appartamento_Interno_Scala_sped: string
    Citta_sped: string
    Provincia_sped: string
    CAP_sped: string
    IndirizzoSpedizioneDiversoDaFatturazione: boolean
    Indirizzo_fatt: string
    Appartamento_Interno_Scala_fatt: string
    Citta_fatt: string
    Provincia_fatt: string
    CAP_fatt: string
    Data_entrata_ordine: Date | null
    Data_inizio_contratto: Date | null
    Tipologia_cessione: string
    Metodo_pagamento: string
    Modalita_pagamento: string
    Preventivo_firmato?: File | null
    Licenza_uso?: File | null  
}

export const createOrderSchemas = (currentStep:any) => {
  let schema = {};

  switch (currentStep) {
    case 2:
      schema = {
        Modello_visore: Yup.array()
          .of(Yup.number())
          .min(1, 'Devi selezionare almeno un modello di visore')
          .required('Modello visore obbligatorio')
          .label('Modello_visore'),
      };
      break;
    case 3:
      schema = {
        Piano_abbonamento: validationConfig.Piano_abbonamento.required
          ? Yup.string().required('Piano abbonamento obbligatorio').label('Piano_abbonamento')
          : Yup.string().label('Piano_abbonamento'),
        Lunghezza_abbonamento: validationConfig.Lunghezza_abbonamento.required
          ? Yup.number().oneOf([3, 6, 9, 12], 'La lunghezza dell\'abbonamento deve essere 3, 6, 9, 12 mesi').required('Lunghezza abbonamento obbligatoria').label('Lunghezza_abbonamento')
          : Yup.number().oneOf([3, 6, 9, 12], 'La lunghezza dell\'abbonamento deve essere 3, 6, 9, 12 mesi').label('Lunghezza_abbonamento'),
        Simulazioni_scelte: Yup.array()
          .of(Yup.string())
          .when('Piano_abbonamento', (piano: string, schema: any) => {
            // Piani con esattamente 6 simulazioni base
            if (['Immersive', 'Immersive + Personalizzato', 'Immersive + Escape Room'].includes(piano)) {
              return schema.length(6, 'Devi selezionare esattamente 6 simulazioni con questo piano');
            }
            // Piani con esattamente 3 simulazioni base
            if (['DiveVR', 'DiveVR + Personalizzato', 'DiveVR + Escape Room'].includes(piano)) {
              return schema.length(3, 'Devi selezionare esattamente 3 simulazioni con questo piano');
            }
            // Piani senza simulazioni base ("Solo …"): nessuna simulazione base ammessa
            if (['Solo Personalizzato', 'Solo Escape Room'].includes(piano)) {
              return schema.max(0, 'Con questo piano non puoi selezionare simulazioni pronte all\'uso');
            }
            // Piani "Matrix": TUTTE le simulazioni base disponibili
            if (['Matrix', 'Matrix + Personalizzato', 'Matrix + Escape Room'].includes(piano)) {
              return schema
                .min(1, 'Simulazioni scelte obbligatorie')
                .test(
                  'matrix-tutte-base',
                  'Con questo piano devi selezionare tutte le simulazioni base disponibili',
                  function (this: any, value: any) {
                    const totale = this.parent.Num_simulazioni_base;
                    return Array.isArray(value) && typeof totale === 'number' && totale > 0 && value.length === totale;
                  }
                );
            }
            // Default: almeno una simulazione
            return schema.min(1, 'Simulazioni scelte obbligatorie');
          })
          .label('Simulazioni_scelte'),
        Simulazioni_multiplayer_scelte: Yup.array()
          .of(Yup.string())
          .when('Piano_abbonamento', (piano: string, schema: any) => {
            if (['Solo Escape Room', 'DiveVR + Escape Room', 'Immersive + Escape Room', 'Matrix + Escape Room'].includes(piano)) {
              return schema
                .length(1, 'Con questo piano devi selezionare solo Escape Room')
                .test(
                  'only-escape-room',
                  'La simulazione multiplayer selezionata deve essere Escape Room',
                  (value: any) => Array.isArray(value) && value.length === 1 && value[0] === 'Escape Room'
                );
            }
            // Altri piani: nessuna simulazione multiplayer ammessa
            return schema.max(0, 'Con questo piano non puoi selezionare simulazioni multiplayer');
          })
          .label('Simulazioni_multiplayer_scelte'),
        Simulazione_personalizzata_scelta: Yup.string()
          .when('Piano_abbonamento', (piano: string, schema: any) => {
            if (['Solo Personalizzato', 'Matrix + Personalizzato', 'Immersive + Personalizzato', 'DiveVR + Personalizzato'].includes(piano)) {
              return schema.required('Devi selezionare una simulazione personalizzata');
            }
            // Altri piani: nessuna simulazione personalizzata ammessa
            return schema.max(0, 'Con questo piano non puoi selezionare una simulazione personalizzata');
          })
          .label('Simulazione_personalizzata_scelta'),
        Opzioni_aggiuntive_scelte: validationConfig.Opzioni_aggiuntive_scelte.required
          ? Yup.array().of(Yup.string()).label('Opzioni_aggiuntive_scelte')
          : Yup.string().label('Opzioni_aggiuntive_scelte'),
        Importo_effettivo: validationConfig.Importo_effettivo.required
          ? Yup.number().min(1, 'L\'importo minimo è 1€').required('Importo effettivo (solo licenze) obbligatorio').label('Importo_effettivo')
          : Yup.number().min(1, 'L\'importo minimo è 1€').label('Importo_effettivo'),
      };
    break;
    case 4:
      schema = {
        Indirizzo_sped: validationConfig.Indirizzo_sped.required
          ? Yup.string().required('Indirizzo di spedizione obbligatorio').label('Indirizzo_sped')
          : Yup.string().label('Indirizzo_sped'),
        Appartamento_Interno_Scala_sped: validationConfig.Appartamento_Interno_Scala_sped.required
          ? Yup.string().required('Appartamento, Interno, scala di spedizione obbligatori').label('Appartamento_Interno_Scala_sped')
          : Yup.string().label('Appartamento_Interno_Scala_sped'),
        Citta_sped: validationConfig.Citta_sped.required
          ? Yup.string().required('Città di spedizione obbligatoria').label('Citta_sped')
          : Yup.string().label('Citta_sped'),
        Provincia_sped: validationConfig.Provincia_sped.required
          ? Yup.string().required('Provincia di spedizione obbligatoria').label('Provincia_sped')
          : Yup.string().label('Provincia_sped'),
        CAP_sped: validationConfig.CAP_sped.required
          ? Yup.string().required('CAP di spedizione obbligatorio').label('CAP_sped')
          : Yup.string().label('CAP_sped'),
        //Checkbox se tenere stesso indirizzo
        IndirizzoSpedizioneDiversoDaFatturazione: Yup.boolean(),
        //Indirizzo di fatturazione
        Indirizzo_fatt: Yup.string()
          .when('IndirizzoSpedizioneDiversoDaFatturazione', {
            is: true,
            then: Yup.string().required('Indirizzo di fatturazione richiesto').label('Indirizzo_fatt'),
            otherwise: Yup.string().notRequired()
        }),
        Appartamento_Interno_Scala_fatt: Yup.string()
          .when('IndirizzoSpedizioneDiversoDaFatturazione', {
            is: true,
            then: Yup.string().label('Appartamento_Interno_Scala_fatt'),
            otherwise: Yup.string().notRequired()
        }),
        Citta_fatt: Yup.string()
          .when('IndirizzoSpedizioneDiversoDaFatturazione', {
            is: true,
            then: Yup.string().required('Città di fatturazione obbligatoria').label('Citta_fatt'),
            otherwise: Yup.string().notRequired()
        }),
        Provincia_fatt: Yup.string()
          .when('IndirizzoSpedizioneDiversoDaFatturazione', {
            is: true,
            then: Yup.string().required('Provincia di fatturazione obbligatoria').label('Provincia_fatt'),
            otherwise: Yup.string().notRequired()
        }),
        CAP_fatt: Yup.string()
          .when('IndirizzoSpedizioneDiversoDaFatturazione', {
            is: true,
            then: Yup.string().required('CAP di fatturazione obbligatoria').label('CAP_fatt'),
            otherwise: Yup.string().notRequired()
        }),
      };
      break;
    case 5:
        schema = {
          Data_entrata_ordine: validationConfig.Data_entrata_ordine.required
            ? Yup.date().nullable().required('Data entrata ordine obbligatoria').max(new Date(), 'La data inserita non può essere successiva a quella odierna').label('Data_entrata_ordine')
            : Yup.string().nullable().label('Data_entrata_ordine'),
          Data_inizio_contratto: validationConfig.Data_inizio_contratto.required
            ? Yup.date().nullable().required('Data inizio contratto obbligatoria').max(new Date(), 'La data inserita non può essere successiva a quella odierna').label('Data_inizio_contratto')
            : Yup.string().nullable().label('Data_inizio_contratto'),
          Tipologia_cessione: validationConfig.Tipologia_cessione.required
            ? Yup.string().oneOf(['Noleggio','Vendita','Comprati loro']).required('Tipologia cessione obbligatoria').label('Tipologia_cessione')
            : Yup.string().label('Tipologia_cessione'),
          Metodo_pagamento: validationConfig.Metodo_pagamento.required
            ? Yup.string().oneOf(['Carta','Paypal','Bonifico','Ri.Ba','SDD','RID']).required('Metodo pagamento obbligatorio').label('Metodo_pagamento')
            : Yup.string().label('Metodo_pagamento'),
          Modalita_pagamento: validationConfig.Modalita_pagamento.required
            ? Yup.string().oneOf(['Unica soluzione','Mensile']).required('Modalità pagamento obbligatoria').label('Modalita_pagamento')
            : Yup.string().label('Modalita_pagamento'),
        };
      break;
      case 6:
        schema = {    
          /* File PDF – Yup.mixed + test sul mime-type */
          Preventivo_firmato: Yup.mixed<File>()
            .required('Preventivo firmato obbligatorio')
            .test(
              'fileType',
              'Il file deve essere un PDF',
              (file) => !!file && file.type === 'application/pdf'
            )
            .label('Preventivo_firmato'),
      
          Licenza_uso: Yup.mixed<File>()
            .required('Licenza d’uso obbligatoria')
            .test(
              'fileType',
              'Il file deve essere un PDF',
              (file) => !!file && file.type === 'application/pdf'
            )
            .label('Licenza_uso'),
        };
      break;
  }
  return Yup.object().shape(schema);
};

export const inits: ICreateOrder = {
  Ragione_sociale: '',
  P_IVA: '',
  CF: '',
  Email: '',
  Email_2: '',
  Referente_commerciale: '',
  IntermediarioRadio: 'No',
  Intermediario: '',
  Modello_visore: [],
  Piano_abbonamento: '',
  Lunghezza_abbonamento: 0,
  Mese_gratis: false,
  Simulazioni_scelte: [],
  Simulazioni_multiplayer_scelte: [],
  Simulazione_personalizzata_scelta: '',
  Num_simulazioni_base: 0,
  Opzioni_aggiuntive_scelte: [],
  Importo_effettivo: 0,
  Note_aggiuntive: '',
  Indirizzo_sped: '',
  Appartamento_Interno_Scala_sped: '',
  Citta_sped: '',
  Provincia_sped: '',
  CAP_sped: '',
  IndirizzoSpedizioneDiversoDaFatturazione: false,
  Indirizzo_fatt: '',
  Appartamento_Interno_Scala_fatt: '',
  Citta_fatt: '',
  Provincia_fatt: '',
  CAP_fatt: '',
  Data_entrata_ordine: null,
  Data_inizio_contratto: null,
  Tipologia_cessione: '',
  Metodo_pagamento: '',
  Modalita_pagamento: '',
  Preventivo_firmato: null,   
  Licenza_uso: null
}